import { Link } from "react-router-dom";
import { ShieldX } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export default function AdminDenied() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen grid place-items-center bg-emerald-950 text-center px-6">
      <div className="max-w-md">
        <ShieldX className="w-14 h-14 text-red-300 mx-auto" />
        <h1 className="mt-5 text-2xl font-serif text-white">Access not authorised</h1>
        <p className="mt-3 text-emerald-100/70">The account {user?.email ? <strong className="text-white">{user.email}</strong> : "you signed in with"} isn't on the approved list for the Emerald Crown lead system.</p>
        <div className="mt-6 flex gap-3 justify-center">
          <Button onClick={logout} variant="outline" className="rounded-full border-white/30 text-white bg-white/5 hover:bg-white/10">Sign out</Button>
          <Link to="/"><Button className="rounded-full bg-brass hover:bg-brass-600 text-emerald-950">Back to site</Button></Link>
        </div>
      </div>
    </div>
  );
}
